import * as React from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
function SvgIconCustomCameraBiggerHeroIcon({
  title,
  titleId,
  ...props
}: React.SVGProps<SVGSVGElement> & SVGRProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 20 20"
      fill="none"
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.561 4.228a3.513 3.513 0 01-1.034 1.109 3.271 3.271 0 01-1.374.54c-.381.058-.759.12-1.136.186-.56.1-.991.633-.991 1.29v9.193c0 .361.135.708.375.964.24.255.567.4.907.4h15.384c.34 0 .666-.145.907-.4.24-.256.375-.603.375-.965V7.354c0-.657-.43-1.191-.99-1.29-.379-.067-.758-.13-1.137-.187a3.272 3.272 0 01-1.374-.54 3.514 3.514 0 01-1.034-1.109l-.002-.004-.847-1.442a1.263 1.263 0 00-.413-.434 1.171 1.171 0 00-.552-.182c-1.749-.1-3.501-.1-5.25 0a1.171 1.171 0 00-.552.182c-.168.107-.31.256-.413.434l-.003.005-.846 1.441zm1.756-3.151a47.036 47.036 0 015.366 0c.36.022.71.137 1.02.335.31.197.571.47.76.798l.844 1.436c.184.31.43.574.72.773.291.199.62.328.962.378.388.058.776.122 1.163.19C19.23 5.178 20 6.19 20 7.354v9.192c0 .65-.243 1.275-.676 1.735a2.24 2.24 0 01-1.632.719H2.308a2.24 2.24 0 01-1.632-.719A2.536 2.536 0 010 16.546V7.354C0 6.19.768 5.178 1.848 4.987c.387-.068.774-.132 1.163-.19.343-.05.67-.179.962-.378.29-.198.537-.463.721-.773l.842-1.436c.19-.327.45-.6.76-.798.31-.198.66-.313 1.02-.335z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.895 7a3.874 3.874 0 00-2.77 1.172A4.044 4.044 0 005.98 11c0 1.06.413 2.078 1.147 2.828A3.874 3.874 0 009.895 15a3.874 3.874 0 002.769-1.172A4.044 4.044 0 0013.81 11c0-1.06-.413-2.078-1.147-2.828A3.875 3.875 0 009.894 7zm-3.461.464A4.843 4.843 0 019.894 6c1.299 0 2.544.527 3.462 1.464A5.055 5.055 0 0114.79 11a5.055 5.055 0 01-1.434 3.536A4.843 4.843 0 019.895 16a4.843 4.843 0 01-3.461-1.464A5.055 5.055 0 015 11c0-1.326.516-2.598 1.434-3.536zm9.58 1.286c0-.276.218-.5.489-.5h.008c.27 0 .489.224.489.5v.008c0 .276-.22.5-.49.5h-.007a.495.495 0 01-.49-.5V8.75z"
        fill="currentColor"
      />
    </svg>
  );
}
export default SvgIconCustomCameraBiggerHeroIcon;
